import React, { useState } from 'react';
import BreadcrumbChevron from '../../../shared/components/BreadcrumbChevron';
import MembershipProductActionsBar from '../../MembershipProductActionsBar';
import { useMembershipProductShowContext } from '../../startup/MembershipProductShowApp';

function formatCurrencyCents(cents) {
  const dollars = (cents || 0) / 100;
  return dollars.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

function StatTile({ label, value }) {
  return (
    <div className="col-md-4 mb-2">
      <div className="text-muted setlist-text-xs setlist-font-medium text-uppercase" style={{ letterSpacing: 0.3 }}>{label}</div>
      <div className="setlist-text-lg setlist-font-semibold">{value}</div>
    </div>
  );
}

function pricingSummary(membershipProduct) {
  const annual = membershipProduct.default_price?.amount_cents;
  const monthly = membershipProduct.default_monthly_price?.amount_cents;
  const parts = [];
  if (annual) parts.push(`${formatCurrencyCents(annual)} / year`);
  if (monthly) parts.push(`${formatCurrencyCents(monthly)} / month`);
  return parts.join(' · ');
}

export default function ProductHeader() {
  const { membershipProduct: initialProduct, team, stats, settingsPath, csrfToken } = useMembershipProductShowContext();
  const [membershipProduct, setMembershipProduct] = useState(initialProduct);

  if (!membershipProduct) return null;
  const indexPath = team ? `/teams/${team.id}/membership_products` : null;
  const editPath = team ? `/teams/${team.id}/membership_products/${membershipProduct.id}/edit` : null;
  const pricing = pricingSummary(membershipProduct);

  return (
    <>
      <nav aria-label="breadcrumb" className="mb-3">
        <div className="d-flex align-items-center flex-wrap" style={{ gap: 4 }}>
          {settingsPath && (
            <a href={settingsPath} className="settings-breadcrumb-link">Settings</a>
          )}
          {indexPath && (
            <>
              <BreadcrumbChevron />
              <a href={indexPath} className="settings-breadcrumb-link">Memberships</a>
            </>
          )}
          <BreadcrumbChevron />
          <span className="settings-breadcrumb-current">{membershipProduct.name}</span>
        </div>
      </nav>
      <div className="team-member-card mb-4">
        <div style={{ padding: 24 }}>
          <div className="d-flex align-items-start justify-content-between flex-wrap" style={{ gap: 16 }}>
            <div className="d-flex align-items-center" style={{ gap: 16, minWidth: 0 }}>
              {membershipProduct.image_thumb_url && (
                <img
                  src={membershipProduct.image_thumb_url}
                  alt={membershipProduct.name}
                  style={{ width: 80, height: 80, objectFit: 'cover', borderRadius: 8, flexShrink: 0 }}
                />
              )}
              <div style={{ minWidth: 0 }}>
                <h2 className="mb-1">{membershipProduct.name}</h2>
                {pricing && <div className="text-muted small mb-2">{pricing}</div>}
                {membershipProduct.description && (
                  <p className="text-muted mb-0">{membershipProduct.description}</p>
                )}
              </div>
            </div>
            <MembershipProductActionsBar
              membershipProduct={membershipProduct}
              team={team}
              csrfToken={csrfToken}
              onProductUpdate={setMembershipProduct}
              trailing={
                editPath && (
                  <a href={editPath} className="team-btn-primary">
                    Edit
                  </a>
                )
              }
            />
          </div>
          {stats && (
            <div className="row mt-3 pt-3 border-top">
              <StatTile label="Active Members" value={stats.active_member_count} />
              <StatTile label="MRR" value={formatCurrencyCents(stats.mrr_cents)} />
              <StatTile label="ARR" value={formatCurrencyCents(stats.arr_cents)} />
            </div>
          )}
        </div>
      </div>
    </>
  );
}
